"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMap = exports.withMap = exports.FabricMapFitBoundsContext = exports.FabricMapPortalContext = void 0;
const react_1 = __importDefault(require("react"));
const react_mapbox_gl_1 = require("react-mapbox-gl");
/**
 * This context provides `FabricMapProviders`'s `setElement` function to `FabricMapHost` components.
 *
 * That allows them to tell `FabricMapProvider` where to render the component.
 */
exports.FabricMapPortalContext = react_1.default.createContext(() => {
    return;
});
/**
 * This context tracks the fitBounds and fitBoundsOptions props passed into FabricMapHost and makes them available to the zoom controls
 */
exports.FabricMapFitBoundsContext = react_1.default.createContext({});
/**
 * Higher order component that provides map to your component's props.
 * If map isn't available, the component won't load.
 */
function withMap(component) {
    return (props) => {
        const Cmp = component;
        const WithMap = (react_1.default.createElement(react_mapbox_gl_1.MapContext.Consumer, null, (map) => (map ? react_1.default.createElement(Cmp, Object.assign({ map: map }, props)) : react_1.default.createElement(react_1.default.Fragment, null))));
        return WithMap;
    };
}
exports.withMap = withMap;
/**
 * Use this hook if you don't want to bother with wrapping your component in an HoC.
 *
 * Will return undefined if there is no map in the provider.
 *
 * @example
 * const map = useMap();
 * map && map.zoomTo({ props });
 */
const useMap = () => {
    return react_1.default.useContext(react_mapbox_gl_1.MapContext);
};
exports.useMap = useMap;
